import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Reference data shared across the app (project types, users, tags, flag types, custom fields). */
export const useRefStore = create((set, get) => ({
  projectTypes: [],
  users: [],
  tags: [],
  flagTypes: [],
  customFields: [],
  loaded: false,
  setRef: (data) => set({ ...data, loaded: true }),
  userName: (id) => id === "system" ? "Systém (automaticky)" : get().users.find((u) => u.id === id)?.full_name || "—",
  typeById: (id) => get().projectTypes.find((t) => t.id === id),
  statusOf: (typeId, statusId) => get().projectTypes.find((t) => t.id === typeId)?.statuses?.find((s) => s.id === statusId),
  tagById: (id) => get().tags.find((t) => t.id === id),
  flagTypeById: (id) => get().flagTypes.find((f) => f.id === id),
}));

export const useUiStore = create(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      contactFilters: { search: "", tags: [], owner_id: "", project_type_id: "", has_project: "" },
      setContactFilters: (f) => set((s) => ({ contactFilters: { ...s.contactFilters, ...f } })),
      taskView: "my",
      setTaskView: (taskView) => set({ taskView }),
      callSettings: { project_type_id: "", status_id: "", tag_id: "" },
      quickTaskSettings: { view: "my", queue: "", order: "smart", project_type_id: "" },
      setQuickTaskSettings: (f) => set((s) => ({ quickTaskSettings: { ...s.quickTaskSettings, ...f } })),
      setCallSettings: (f) => set((s) => ({ callSettings: { ...s.callSettings, ...f } })),
      selectedContactId: null,
      setSelectedContactId: (selectedContactId) => set({ selectedContactId }),
    }),
    { name: "crm-ui" }
  )
);
